module.exports = __webpack_public_path__ + "img/1527846432.9cabb8c1.jpg";